// react
import React, { useEffect, useState } from "react";

const CircuitCenter = (props) => {

	const [icons, setIcons] = useState([])

	useEffect(() => {
		//console.log(props.id === props.menu)
		if(props.content){
			let iconsTemp = []
			for(let p of props.content.products){
				if(p.section === props.id){
					iconsTemp.push(p)
				}
			}
			setIcons(iconsTemp)
		}
		
	}, [props.content])

	return (
		<React.Fragment>

			{/* child icons */}
			{icons.map(i => (
				<React.Fragment>
					<div
						key={i.id}
						className={"icon icon-horizontal"}
						style={{
							top:i.position.landscape && i.position.landscape.top,
							left:i.position.landscape && i.position.landscape.left,
							//display: props.menu !== null ? "block" : "none"
						}}
					>
						<div
							className={"icon-bg icon-small "+(props.menu !== null ? "circuit-hover" : "" )+""}
							style={{
								//backgroundImage:"url('"+i.icon+"')"
							}}
							onClick={() => props.popup(i.id)}
						></div>
					</div>
					<div
						key={i.id}
						className={"icon icon-vertical"}
						style={{
							top:i.position.portrait && i.position.portrait.top,
							left:i.position.portrait && i.position.portrait.left,
							//display: props.menu !== null ? "block" : "none"
						}}
					>
						<div
							className={"icon-bg icon-small "+(props.menu !== null ? "circuit-hover" : "" )+""}
							style={{
								//backgroundImage:"url('"+i.icon+"')"
							}}
							onClick={() => props.popup(i.id)}
						></div>
					</div>
				</React.Fragment>
			))}

            {/* circuit */}
			<div
				className={"circuit circuit-center"}
				style={{opacity: props.menu !== null ? 0 : 1 }}
			></div>

		</React.Fragment>
	)
}

export default CircuitCenter;